import moment from "moment";
import React from "react";
import ResponsivePagination from "react-responsive-pagination";

import CONSTANT from "../../../constant";
// import Header from '../../../component/common/UnitLeaveHeader';
import { getPrintLog, serachPrintLog } from "../../../actions/UnitLeaveAction";
import Header from "../../../component/common/AdminHeader";

class ComponentName extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      page: 1,
      list: undefined,
      total: 0,
      showLoader: false,
      keyword: "",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = CONSTANT.pageTitle.adminSection;
    this.loadList(this.state.page);
  }

  render() {
    const { list } = this.state;
    return (
      <div className="container-fluid">
        <div className="row mb-3">
          {/* <div className="col-md-2 px-0">
            <Header />
          </div> */}
          <div className="col-md-12">
            <div className="card homedob">
              <div className="row">
                <div className="col-md-12">
                  <h1 className="page-title">Print Log Report</h1>
                </div>
                <div className="row mt-3">
                  <div className="col-md-6">
                    <form className="searchhome">
                    <i className="fa fa-search d-inline-block"></i>
                    <input
                      type="text"
                      name="k"
                      className="form-control search-bar d-inline-block"
                      placeholder="Search by employee no, designation and department"
                      onChange={this.onChange}
                    />
                    </form>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mt-3">
                  <div className="list-container">
                    <div className="table-container">
                    <div className="table-wrapper radius-4">
                    <table className="tablen print-log-table">
                      <thead>
                        <tr>
                          <th scope="col" className="text-nowrap">S.No.</th>
                          <th scope="col" className="text-nowrap">File Number</th>
                          <th scope="col" className="text-nowrap">Subject</th>
                          <th scope="col" className="text-nowrap">Print BY</th>
                          <th scope="col" className="text-nowrap">Reason</th>
                          <th scope="col" className="text-nowrap">Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list === undefined && (
                          <tr>
                            <td colSpan={10} className="text-center">
                              Loading...
                            </td>
                          </tr>
                        )}
                        {list !== undefined && list.length === 0 && (
                          <tr>
                            <td colSpan={10} className="text-center">
                              No records found
                            </td>
                          </tr>
                        )}
                        {list !== undefined &&
                          list.map((item: any, index: number) => {
                            return (
                              <tr className="c-pointer" key={index}>
                                <td>{index + 1}</td>
                                <td>{item?.fileNumber}</td>
                                <td>{item?.subject}</td>
                                <td>{item?.name}</td>
                                <td>{`${item?.print_reason}`}</td>
                                <td>{`${moment(item?.print_timestamp).format(
                                  "DD/MM/YYYY"
                                )}`}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                    </div>
                    </div>
                    <div className="mt-4 p-4">
                      {list !== undefined && list.lenght !== 0 && (
                        <ResponsivePagination
                          activeItemClassName="Pagi-number-ac"
                          current={this.state.page}
                          maxWidth={1}
                          total={Math.ceil(this.state.total / 10)}
                          onPageChange={this.handlePageChange}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* {showLoader && <Loader />} */}
      </div>
    );
  }

  loadList = (page: any) => {
    this.setState({ showLoader: true });
    getPrintLog(page).then((res: any) => {
      this.setState({
        list: res.result?.printLogsWithDetails,
        total: res.result?.total,
        showLoader: false,
      });
    });
  };

  onSubmit = (page: any) => {
    this.setState({ showLoader: true });
    getPrintLog(page).then((res: any) => {
      this.setState({
        list: res.result?.printLogsWithDetails,
        total: res.result?.total,
        showLoader: false,
      });
    });
  };

  onChange = (e: any) => {
    this.setState({
      keyword: e.target.value,
    });
    if (e.target.value != "") {
      serachPrintLog({ keyword: e.target.value }).then((res: any) => {
        this.setState({
          list: res.result?.printLogsWithDetails,
        });
      });
    } else {
      this.loadList(this.state.page);
    }
  };

  handlePageChange = (newPage: number) => {
    this.setState({ page: newPage }, () => {
      this.loadList(newPage);
    });
  };
}

export default ComponentName;
